import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SourceStatusService {



  url = environment.serverAPI9 + "/api/source/status/user/report";

  constructor(private http: HttpClient) { }

  searchDynamicLeadReport(query: string, page: number, size: number, sort: string, groupBy: any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy

    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url}${queryParams}`, requestBody);
  }


}
